import Business from "@mui/icons-material/Business";
import ChevronLeft from "@mui/icons-material/ChevronLeft";
import { Box, IconButton, Stack, Tooltip, Typography } from "@mui/material";
import { useAtomValue } from "jotai";
import { type FC, useState } from "react";
import { PipeIFrame } from "../../../../pipe/components/pipe-iframe";
import type { Login } from "../../../../pipe/types";
import { layoutAtom } from "../../store";
import { useLogo } from "../hooks/use-logo";
import { SettingsMenu } from "../settings-menu";
import type { NavigationProps } from "./types";

export const NavHeader: FC<NavigationProps> = ({ onClose }) => {
  const [logins, setLogins] = useState<{ [k: string]: Login }>({});
  const layout = useAtomValue(layoutAtom);

  const { data } = useLogo();

  return (
    <Stack alignItems="center" direction="row" spacing={1} p={2}>
      {layout === "content" && onClose && (
        <IconButton data-analytics-id="sidebar-close" onClick={onClose}>
          <ChevronLeft />
        </IconButton>
      )}
      <Box
        sx={{
          height: 35,
          width: 35,
          flexBasis: 40,
          flexShrink: 0,
        }}
      >
        {data?.logo ? (
          <img
            alt="logo"
            src={data?.logo}
            style={{
              objectFit: "contain",
              height: "100%",
              width: "100%",
            }}
          />
        ) : (
          <Business />
        )}
      </Box>
      <Tooltip title={data?.name ?? ""}>
        <Typography color="inherit" whiteSpace="nowrap" flexGrow={1} noWrap>
          {data?.name ?? ""}
        </Typography>
      </Tooltip>
      {["default", "content"].includes(layout) && <SettingsMenu size="small" logins={logins} />}
      {data?.name && data?.account_id ? (
        <PipeIFrame setLogins={setLogins} name={data.name} account_id={data.account_id} />
      ) : null}
    </Stack>
  );
};
